export default {
    SET_DISPOSISI_TERBARU(state, data){
        state.kinerja.disposisiTerbaru = data
    },
    SET_RATING_PERBIDANG(state, data){
        state.kinerja.ratingPerbidang = data
    },
    SET_RATING_TERBARU(state, data){
        state.kinerja.ratingTerbaru = data
    },
    SET_KINERJA(state,data){
        state.kinerja.kinerja = data
    },
    SET_STATISTIK_IZIN(state,data){
        state.statistik.statistikIzin = data
    },
    SET_GRAFIK_PERMOHONAN(state,data){
        state.statistik.grafikPermohonan = data
    },
    SET_GRAFIK_PERMOHONAN_PERBIDANG(state,data){
        state.statistik.grafikPermohonanPerbidang = data
    },
    SET_GRAFIK_VERIFIKASI_PERBIDANG(state,data){
        state.statistik.grafikPermohonanVerifikasiPerbidang = data
    },
    SET_GRAFIK_PERMOHONAN_PERBULAN(state,data){
        state.statistik.grafikPermohonanPerbulan = data
    },
    SET_GRAFIK_PERMOHONAN_PERBULAN_GENAP(state,data){
        state.statistik.grafikPermohonanPerbulanGenap = data
    },
    SET_GRAFIK_PERMOHONAN_SELESAI_PERBIDANG(state,data){
        state.statistik.grafikPermohonanSelesaiPerbidang = data
    },
    SET_GRAFIK_PERMOHONAN_PERMINGGU(state,data){
        state.statistik.grafikPermohonanPerminggu = data
    },

}
